import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { DATA_AMOUNT } from '../../consts';
import { formatAmount } from './auction_formatter';
import { NOTIFICATIONS } from '../../auction_manager/notifications';

$(() => {
  const instantBidButtons = $('#instant-bid .pill-bid-option');
  const startBidButton = $('#start-bidding-button');
  const currentBidDisplayElement = $('#current-bid-amount');
  const newBidDisplayElement = $('#bid-amount');
  const currentBidInModalDisplayElement = $('#current-amount-in-modal');
  const startBid = parseInt($('#_bid-start-amount').val()) || 0;

  const getCurrentBid = () => {
    const currentBid = currentBidDisplayElement
      .get(0)
      .getAttribute(DATA_AMOUNT);
    return currentBid;
  };

  const onInstantBidClicked = (event) => {
    const bidAmount = event.target.getAttribute(DATA_AMOUNT);
    const currentBid = getCurrentBid();
    const newBid = parseInt(currentBid) + parseInt(bidAmount);
    newBidDisplayElement
      .text(formatAmount(newBid))
      .attr('data-bid-value', newBid);
    currentBidInModalDisplayElement.text(formatAmount(currentBid));
    EVENT_BUS.dispatch(AUCTION_EVENTS.INSTANT_BID_MODAL_OPENED, {
      bidValue: newBid,
    });
  };

  const onStartBidClicked = () => {
    const currentBid = getCurrentBid();
    newBidDisplayElement
      .text(formatAmount(startBid))
      .attr('data-bid-value', startBid);
    currentBidInModalDisplayElement.text(formatAmount(currentBid));
    EVENT_BUS.dispatch(AUCTION_EVENTS.INSTANT_BID_MODAL_OPENED, {
      bidValue: startBid,
    });
  };

  const updateStartBidButtonState = ({ bids }) => {
    if (bids.length) {
      startBidButton.hide();
    }
  };

  instantBidButtons.on('click', onInstantBidClicked);
  startBidButton.on('click', onStartBidClicked);

  EVENT_BUS.on(AUCTION_EVENTS.AUCTION_STATUS_UPDATED, (event) => {
    const { bids } = event;
    updateStartBidButtonState({ bids });
    instantBidButtons.prop('disabled', false);
  });

  EVENT_BUS.on(AUCTION_EVENTS.AUTO_BID_CONFIRMED, () => {
    instantBidButtons.prop('disabled', true);
  });

  EVENT_BUS.on(AUCTION_EVENTS.INSTANT_BID_CONFIRMED, () => {
    instantBidButtons.prop('disabled', true);
  });

  EVENT_BUS.on(AUCTION_EVENTS.SHOW_NOTIFICATION, ({ notification }) => {
    if (
      [
        NOTIFICATIONS.BID_PLACED_WHILE_RESERVE_MET_AND_HIGHEST_BIDDER,
        NOTIFICATIONS.AUTO_INCREMENT_PLACED,
        NOTIFICATIONS.UNEXPIRED_AUTO_INCREMENT_ALREADY_EXIST,
      ].includes(notification)
    ) {
      instantBidButtons.prop('disabled', false);
    }
  });

  $(window).on('unload', () => {
    instantBidButtons.off('click', onInstantBidClicked);
  });
});
